<template>

<div :class="{'hide': loading}" style="overflow: hidden;">
<div :class="{'spinner loading': loading}"></div>



	<div class="form-box-items wrap-3-1 left">
		<!-- FORM BOX ITEM -->
		<div class="form-box-item full not-padded not-spaced">
			<h4>Discount progress</h4>
			<hr class="line-separator">
			<!-- POPULAR ITEMS -->
			<div class="popular-items">
				<!-- POPULAR ITEM -->
				<div class="popular-item">
					<div class="popular-item-info">
						<p class="text-header small" v-bind:class="{ 'line-through': isCrossed(10) }">10% discount</p>
						<p class="category primary">10+ pages written with us</p>
					</div>
					<div class="popular-item-meta">
						<button v-if="$user.pages_ordered >= 10 || $user.user.discount >= 10"  style="width: 100px;" class="button primary">Unlocked</button>
						<button v-else style="width: 145px;" class="button dark-light">order {{10 - $user.user.pages_ordered}} pages to unlock</button>
					</div>
				</div>
				<!-- /POPULAR ITEM -->

				<!-- POPULAR ITEM -->
				<div class="popular-item">
					<div class="popular-item-info">
						<p class="text-header" v-bind:class="{ 'line-through': isCrossed(15), 'underline': underlined(15) }">15% discount</p>
						<p class="category primary">50+ pages written with us</p>
					</div>
					<div class="popular-item-meta">
						<button v-if="$user.pages_ordered >= 50 || $user.user.discount >= 15"  style="width: 100px;" class="button primary">Unlocked</button>
						<button v-else style="width: 145px;" class="button dark-light">order {{50 - $user.user.pages_ordered}} pages to unlock</button>
					</div>
				</div>
				<!-- /POPULAR ITEM -->

				<!-- POPULAR ITEM -->
				<div class="popular-item">
					<div class="popular-item-info">
						<p class="text-header" v-bind:class="{ 'line-through': isCrossed(20), 'underline': underlined(20) }">20% discount</p>
						<p class="category primary">100+ pages written with us</p>
					</div>
					<div class="popular-item-meta">
						<button v-if="$user.pages_ordered >= 100 || $user.user.discount >= 20"  style="width: 100px;" class="button primary">Unlocked</button>
						<button v-else style="width: 145px;" class="button dark-light">order {{100 - $user.user.pages_ordered}} pages to unlock</button>
					</div>
				</div>
				<!-- /POPULAR ITEM -->

				<!-- POPULAR ITEM -->
				<div class="popular-item">
					<div class="popular-item-info">
						<p class="text-header" v-bind:class="{ 'line-through': isCrossed(30), 'underline': underlined(30) }">30% discount</p>
						<p class="category primary">250+ pages written with us</p>
					</div>
					<div class="popular-item-meta">
						<button v-if="$user.pages_ordered >= 250 || $user.user.discount >= 30"  style="width: 100px;" class="button primary">Unlocked</button>
						<button v-else style="width: 145px;" class="button dark-light">order {{250 - $user.user.pages_ordered}} pages to unlock</button>

					</div>
				</div>
				<!-- /POPULAR ITEM -->

				<!-- POPULAR ITEM -->
				<div class="popular-item">
					<div class="popular-item-info">
						<p class="text-header" v-bind:class="{ 'line-through': isCrossed(50), 'underline': underlined(50)}">Special offer</p>
						<p class="category primary">500+ pages written with us</p>
					</div>
					<div class="popular-item-meta">
						<button v-if="$user.pages_ordered >= 500 || $user.user.discount > 30"  style="width: 100px;" class="button primary">Unlocked</button>
						<button v-else style="width: 145px;" class="button dark-light">order {{500 - $user.user.pages_ordered}} pages to unlock</button>
					</div>
				</div>
				<!-- /POPULAR ITEM -->
			</div>
			<!-- /POPULAR ITEMS -->
		</div>
		<!-- /FORM BOX ITEM -->
	</div>

	<div class="form-box-items wrap-1-3 right">
		<!-- FORM BOX ITEM -->
		<div class="form-box-item full">
			<h4>Your discount</h4>
			<hr class="line-separator">
			<div class="bounce-pie-chart xmpiechart" style="width: 200px; height: 200px; position: relative;">
				<p class="text-header big bounce-perc-link">{{$user.user.discount}}<span>%</span></p>
				<p class="text-header">Lifetime</p>
				<p>Applies automatically</p>
				<canvas width="200" height="160" style="position: absolute; z-index: 0; top: 0px; left: 0px;"></canvas><canvas class="chartLine" width="200" height="200" style="position: absolute; z-index: 1; top: 0px; left: 0px;"></canvas></div>
		</div>
		<!-- /FORM BOX ITEM -->
	</div>

</div>
</template>


<script>

    export default {
        // props: ['person'],

        data() {
            return {
                loading: true,
            }
        },


        created(){
			this.loading = false;


        },


        methods: {

            isCrossed(discount) {
                if(this.$user.user.discount > discount) {
                    return true
                }
			},

            underlined(discount) {
                if(this.$user.user.discount === discount) {
                    return true
                }
			}



        },
    }
</script>